import { type Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';

import { getAuthConfig } from './loadConfig';

const authConfig = getAuthConfig();

export const msalConfig: Configuration = {
    auth: {
        clientId: authConfig.clientId,
        authority: `https://login.microsoftonline.com/${authConfig.tenantId}`,
        redirectUri: authConfig.redirectUrl,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
    },
    system: {
        loggerOptions: {
            loggerCallback(level, message, containsPii) {
                if (containsPii) return;
                if (level === LogLevel.Error) console.error('[MSAL]', message);
                if (level === LogLevel.Warning) console.warn('[MSAL]', message);
            },
        },
    },
};

export const loginRequest = {
    scopes: ['openid', 'profile', 'User.Read'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
